import { SET_NOTIFICATIONS, ADD_NOTIFICATION, REMOVE_NOTIFICATION, RESET_NOTIFICATIONS } from 'reducers/actions-types';
import { fetch } from './helpers';

export default {
    add({ notification }) {
        return { type: ADD_NOTIFICATION, notification };
    },
    remove({ notification }) {
        return { type: REMOVE_NOTIFICATION, notification };
    },
    reset() {
        return { type: RESET_NOTIFICATIONS };
    },
    set({ notifications }) {
        return { type: SET_NOTIFICATIONS, items: notifications };
    },
    fetch,
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/notifications/actions.js